import React from 'react';
import '../App.css';

const Creative = () => {
	return (
		<>
			<div className='writer'>
				<h1 className='pagetitles'>Switch()</h1>
				<p className='projectdesc'>
					a journey from art to code. <br />
					<br />
					Switch()
					<br />
					in javascript: <br />
					-executes a block of code depending on different cases. used to
					perform different actions based on conditions.
					<br />
					<br />
					Switch
					<br />
					in life: <br /> <span>(verb)</span> <br />
					-to change the position, direction, or focus of.
					<br />
					<br /> coming soon.
				</p>
			</div>
			<div className='actor'>
				<h1 className='pagetitles'>Commercial Reel</h1>
				<p className='projectdesc'>
					auditioning for and shooting commercials brings me joy. here is a
					quick highlight reel of some of the jobs I've done. <br />
					<br /> coming soon!
				</p>
			</div>
		</>
	);
};

export default Creative;
